import React from 'react';
import type { IconProps } from '../types';

export const IconFullscreenExit = (props: IconProps) => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>fullscreen-exit</title>
    <g
      id="fullscreen-exit"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="fullscreen-exit-icon"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Top-left corner - arrows pointing inward */}
        <polyline
          points="8 3 8 8 3 8"
        />
        {/* Top-right corner - arrows pointing inward */}
        <polyline
          points="17 8 12 8 12 3"
        />
        {/* Bottom-right corner - arrows pointing inward */}
        <polyline
          points="12 17 12 12 17 12"
        />
        {/* Bottom-left corner - arrows pointing inward */}
        <polyline
          points="3 12 8 12 8 17"
        />
      </g>
    </g>
  </svg>
);

export default IconFullscreenExit;
